import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EmbroideredBrisbaneRoutingModule } from './embroidered-workwear-brisbane.routing.module';
import { EmbroideredBrisbaneComponent } from './embroidered-workwear-brisbane.component';


@NgModule({
  declarations: [
    EmbroideredBrisbaneComponent
  ],
  imports: [
    CommonModule,
    EmbroideredBrisbaneRoutingModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class EmbroideredBrisbaneModule { }
